import { BehaviorSubject } from 'rxjs'
import { combineEpics, Epic } from 'redux-observable'
import { mergeMap } from 'rxjs/operators'
import triggerToken$ from './token/triggerFetch'
import fetchToken$ from './token/fetchToken'
import debugPolling$ from './debugPolling'
import errorLogger$ from './errorLogger'
import { windowBlur$, windowFocus$ } from './tabVisibility'
import user from './user'
import room$ from './room'
import syncClient$ from './syncClient'
import docs$ from './docs'
import mediaType from './mediaType'
import tracks$ from './tracks'
import polling$ from './polling'
import dialIn$ from './dialIn'
import notifications$ from './notifications'
import deadMansHandle$ from './gig/deadMansHandle'
import rescheduled from './gig/rescheduledFetch'
import eventStreamDetails$ from './eventStream/eventStreamDetails'
import updateLayouts$ from './layouts/updateLayouts/index'
import featureFlags$ from './featureFlags'
import updateQuestions$ from './questions/index'
import { epic$, addStream } from './epicStore'
import { systemCheck$, systemCheckReport$ } from './systemCheck/systemCheck'

addStream(combineEpics(
    user.disconnect$,
    fetchToken$,
    room$,
    docs$,
    syncClient$,
    debugPolling$,
    errorLogger$,
    windowBlur$,
    windowFocus$,
    deadMansHandle$,
    rescheduled.rescheduledFetch$,
    rescheduled.rescheduledFetchPoll$,
    triggerToken$,
    mediaType.playInMediaType$,
    mediaType.forceLocalMute$,
    tracks$,
    polling$,
    notifications$,
    eventStreamDetails$,
    updateLayouts$,
    dialIn$,
    systemCheck$,
    systemCheckReport$,
    featureFlags$,
    updateQuestions$
  )
)

export let rootEpic: Epic | null = null

if (epic$ !== null) {

  rootEpic = (action$, state$, dependencies) => (epic$ as BehaviorSubject<Epic>).pipe(
    mergeMap((epic: Epic) => epic(action$, state$, dependencies))
  )

}

export default rootEpic
